import { render, staticRenderFns } from "./AddMiniProjectCurriculam.vue?vue&type=template&id=4ea6b3a8&scoped=true"
import script from "./AddMiniProjectCurriculam.vue?vue&type=script&lang=js"
export * from "./AddMiniProjectCurriculam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6b3a8",
  null
  
)

export default component.exports